// "2010-05-03" -> "03.05.2010". Works on the string so time zones can't shift the day.
export const formatDate = (iso) => {
  if (!iso) return "";
  const [y, m, d] = String(iso).slice(0, 10).split("-");
  return y && m && d ? `${d}.${m}.${y}` : "";
};
